import { render, staticRenderFns } from "./SupervisionPlatform.vue?vue&type=template&id=26458854&scoped=true&"
import script from "./SupervisionPlatform.vue?vue&type=script&lang=js&"
export * from "./SupervisionPlatform.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionPlatform.vue?vue&type=style&index=0&id=26458854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26458854",
  null
  
)

export default component.exports